import { API } from "../../backend";

export const getAllCategories = () => {
  return fetch(`${API}/category/getAll`, {
    method: "GET",
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log(err));
};

export const getAllCategoriesUnderParent = (id) => {
  return fetch(`${API}/category/get/${id}`, {
    method: "GET",
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log(err));
};

export const getBranchedCategories = () => {
  return fetch(`${API}/category/getAllCategories`, {
    method: "GET",
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => {
      console.log(err);
    });
};
